import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { setLoader, setDeeplink, setParams } from "../../../redux/actions";
import {
  Row,
  Button,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Badge,
  CustomInput,
  UncontrolledTooltip,
  Alert,
  Modal
} from "reactstrap"
import CircularProgressbar from "react-circular-progressbar"
import AppLocale from "../../../config/lang"
import _axios from "../../../libs/axios"
import _moment from "../../../libs/moment"
import { cloneDeep } from "lodash"
import { objToQueryString, decimalFormat, findModuleInMenu } from "../../../helpers/Utils"
import { Colxx } from "../../../components/common/CustomBootstrap"
import DataTable from "../../../components/utils/DataTable"
import FormCustom from "../../../components/utils/FormCustom"
import FormSmart from "../../../components/utils/FormSmart"
import CustomDropdown from "../../../components/utils/CustomDropdown"
import Dialog from "../../../components/utils/Dialog"
import { NotificationManager } from "../../../components/common/react-notifications"
import ExportTo from "../../../components/utils/ExportTo"
import ImportTo from "../../../components/utils/ImportTo"
import modules from "../../../config/admModules/modules"
import SideToSide from "../../../components/utils/SideToSide"
import dateRange from "../../../components/utils/DateRange"
import CustomModal from "../../../components/utils/CustomModal"
// import Breadcrumb from "../../../containers/navs/Breadcrumb"
// import { DataListIcon, ThumbListIcon } from "../../../components/svg"

class CrudGrid extends Component {
  constructor(props) {
    super(props);
    this.view = (() => {
      let mod = props.embeded 
        ? { id: props.module, path: props.match.path, module: props.embeded }
        : modules.find(m => m.path === props.match.path)

      let modOption = findModuleInMenu(props.menuItems, "to", props.match.path)

      if (!modOption) return

      let moduleConfig = mod.module(this)

      if (props.config) {
        if (props.config.filter) moduleConfig.filter = props.config.filter
        const { filter, ...restConfig } = props.config
        moduleConfig.config = { ...moduleConfig.config, ...restConfig }
      }

      if (mod && modOption) {
        modOption = { ...moduleConfig, ...modOption }
        return modOption
      }
      else return moduleConfig
    })();

    let writePermission = false

    if (this.view) {
      // setup date range for form filter 
      const index = this.view.filter?.fields.findIndex(e => e.type === "daterange")
      if (index > -1) this.view.filter.fields.splice(index, 1, ...dateRange(this.view.filter.fields[index]))

      // setup date range for form crud 
      if (this.view.form?.fields) {
        let fields = cloneDeep(this.view.form.fields)
        let pos = 0
        fields.forEach((item, index) => {
          if(item.type === "daterange") {
            this.view.form.fields.splice(index + pos, 1, ...dateRange(this.view.form.fields[index + pos]))
            pos+=2
          }

          const w = item.type === 'wizard' ? item : null
          if (w) {
            w.steps.forEach((step, index2) => {
              let pos2 = 0
              step.fields.forEach((field, index3) => {
                if(field.type === "daterange") {
                  w.steps[index2].fields.splice(index3 + pos2, 1, ...dateRange(w.steps[index2].fields[index3 + pos2]))
                  pos2+=2
                }
              })
            })
            this.view.form.fields[index] = w
          }
        })
      }
      
      // setup module
      let configFields = null
      const moduleName = this.view.id // props.match.path.split('/').slice(-1)[0]
      const menuSubs = props.menuItems.flatMap((m) => m.subs || [])
      const foundModule = menuSubs.find((s) => s.id === moduleName)
      if (foundModule) configFields = foundModule.configFields

      if (this.view.form?.fields) {
        this.view.form.fields = this.view.form.fields
        .map(f => ({
          ...f,
          ...((configFields?.[f.name]) || {})
        }))
        .filter(f => !f.inactive)
      }
      
      // write permissions
      writePermission = props.userAdmin.write.indexOf(this.view.id) > -1
      if (!writePermission) {
        this.view.actions.create = false
        this.view.actions.delete = false
        if (this.view.form?.fields) {
          this.view.form.fields.map(f => {if(!f.modulePermissions) f.disabled = true; return f})
        }
      }
      // fields with permissions from other modules
      if (this.view.form?.fields) {
        this.view.form.fields.map(f => {if(f.modulePermissions) f.disabled = props.userAdmin.write.indexOf(f.modulePermissions) === -1; return f})
      }

      if (props.ctx) props.ctx(this)
    }

    this.viewDefault = cloneDeep(this.view)

    this.state = {
      L: AppLocale[this.props.locale]?.messages,
      parentId: props.parentId,
      authorized: this.view ? true : false,
      resource: null,
      data: [],
      columns: [],
      pageSize: 0,
      rowCount: 0,
      pageCount: 0,
      currentPage: 1,
      progressBar: false,
      hidePagination: false,
      formFilter: null,
      search: '',
      modal: false,
      modalRight: false,
      modalRightSize: "lg",
      modalRightContent: null,
      modalDelete: false,
      toggleGenericVisible:false,
      modalGeneric: { title:'', msg:''},
      idItemSelected: null,
      idItemPreSelected: null,
      
      form: null, // component customForm values
      formDefault: null, // component customForm original values
      formFlags: null, // component customForm flags
      formFlagsDefault: null, // component customForm save default flags
      formFields: this.view?.form?.fields, // component customForm 
      animateTr: null,
      dataTableList: this.view?.config?.list,
      // upload files
      dropzones: [],
      uploadActive: 0,
      uploadFiles: null,
      writePermission: writePermission,

      btnCancel: "main.cancel",
      btnSave: "main.save",
      btnCreate: "main.create",
      customMsg: null,
      msgNoRecords: null,
      checkedList: [],
      hideBtnSave: this.view?.config?.hideBtnSave,
      showFormCustom: false,
      wizard: this.view?.form?.fields?.find(f => f.type === "wizard"), // this.view?.form?.fields?.some(f => f.type === "wizard"),
      dropdown: false,
      selects: null, // stores key, value and label of the selection fields
      preview: null,
      modalPreview: false,
      cloning: false
    }
  }

  UNSAFE_componentWillMount() {
    if (this.state.authorized) {
      if (this.view) this.setState({ pageSize: this.view.config.pageSize, hidePagination: !!this.view.config.hidePagination, resource: this.view.config.resource || this.view.id})
      if (this.view.form && this.view.form.flags) {
        this.setState({ formFlagsDefault: this.viewDefault.form.flags });
        this.setState({ formFlags: this.view.form.flags });
      }
      if (this.props.deepLink) {
        if(this.props.deepLink.keepFilters) {
          this.view.filter.fields.forEach((e, i) => {
            let obj = this.props.deepLink.params.find(p => p.name === e.name )
            if (obj) this.view.filter.fields[i] = obj
          });
          this.view.filter.fields = this.view.filter.fields.concat(this.props.deepLink.params)
          // remove duplicate parameters
          this.view.filter.fields = [...new Map(this.view.filter.fields.map(item => [item.name, item])).values()]
        } else this.view.filter.fields = this.props.deepLink.params
      }
    }
  }

  componentDidMount() {
    if (this.state.authorized) {
      this.actionsInColumns()
      if (!this.view.filter && !this.props.onlyCrud && !this.view.config.hiddenGrid) this.getData()
    } else NotificationManager.error("No tienes permiso para acceder a este módulo: " + this.props.match.path, "No autorizado", 3000, null, null, 'outline')
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.locale !== this.props.locale) {
      this.setState({L: AppLocale[this.props.locale].messages})
    }
    if (this.state.authorized) {
      if (prevState.formFilter === null && this.state.formFilter) {
        setTimeout(() => { this.getData() }, 150)
      }
      if (prevState.data !== this.state.data) {
        if (this.props.listenData) this.props.listenData(this.state.data)
        if (this.view.preview?.previewOf?.grid) this.previewOfGrid(this.state.data)
      }
      if (prevState.form !== this.state.form) {
        if (this.props.listenForm) this.props.listenForm(this.state.form)
        if (this.view.preview?.previewOf?.form) this.previewOfForm(this.state.form)
      }
    }
  }

  componentWillUnmount() {
    const currentId = this.view?.id
    this.viewDefault = null
    this.view = null
    // Keep outbound deeplink so the target module can apply filters after navigation
    const dl = this.props.deepLink
    const targetId = dl?.module ? String(dl.module).split("/").filter(Boolean).pop() : null
    if (!dl || !targetId || targetId === currentId) {
      this.props.setDeeplink(null)
    }
    this.props.setParams(null)
  }

  actionsInColumns(customEditIcon) {
    let temp = cloneDeep(this.view.columns)?? []
    const fDate = (props, format) => {
      if (!props.value || !_moment(props.value).isValid()) return ''
      // Parse date assuming server time is GMT-5, keeping the time values but setting the offset
      const serverDate = _moment(props.value).utcOffset(-5, true)
      // Convert to local user time
      const localDate = serverDate.local()
      return localDate.format(format || `${window.tenant.defaultDateFormat} ${window.tenant.defaultTimeFormat}`)
    }
    const colImg = props => <div className="img-col-table"><img alt="Profile" src={props.value?? require("../../../assets/img/user.png")} onError={(e) => { e.target.onerror = null; e.target.src = require("../../../assets/img/user.png") }} /></div>
    temp.forEach((e, i) => {
      if (e.isBool) temp[i].Cell = props => <div className="cell-type"><i className={(props.value ? 'simple-icon-check' : '')} style={{ fontSize: '1.2rem' }} /></div>
      else if (e.isDate) temp[i].Cell = props => fDate(props, e.format)
      else if (e.isDecimal) temp[i].Cell = props => decimalFormat(props.value)
      else if (e.type && e.type === 'chip') temp[i].Cell = props => <div><Badge color={null} style={{backgroundColor: e.chips[props.value]?.color, color: '#fff'}} pill>{e.chips[props.value]?.text} </Badge></div>
      else if (e.type && e.type === 'html') temp[i].Cell = e.cell
      else if (e.type && e.type === 'img') temp[i].Cell = colImg
      else if (e.type && e.type === 'progress') temp[i].Cell =  props => <div style={{ width: 50, height: 50 }}><CircularProgressbar strokeWidth={2} percentage={props.value} text={`${props.value}%`}/></div>
      else if (e.type && e.type === 'check') {
        temp[i].Cell = (props) => {
          if (props.value) {
            return <div className="checkbox-in-column">
              <CustomInput
                type="checkbox"
                id={e.id +'-'+ props.index}
                defaultChecked={props.original['isChecked_'+e.accessor]}
                onClick={()=> {
                  props.original['isChecked_'+e.accessor] = !props.original['isChecked_'+e.accessor]
                  let list = this.state.checkedList
                  const i = list.findIndex(item => item.rowId === props.original.ID && item.colId === e.accessor && item.mail === props.value)
                  i > -1 ? list.splice(i, 1) : list.push({rowId: props.original.ID, colId: e.accessor , mail: props.value})
                }}
              />
              <UncontrolledTooltip
                placement="right"
                target={e.id +'-'+ props.index}>
                {props.value}
              </UncontrolledTooltip>
            </div>
          } else return ''
        }
      }
      // concept
      else if (e.type && e.type === 'concept') temp[i].Cell = (props) => { 
        return <div className={props.original.level === 0 ? '' : "concept-child"} style={{marginLeft: (props.original.level*20) + 'px'}}>{props.value}</div>
      }
      /* end admEvalConcept */
    });

    const edit = {
      width: 50,
      Cell: props => <i className={(customEditIcon?? ((this.state.writePermission ? "simple-icon-pencil" : "simple-icon-eye"))) + " icon-action d-flex align-items-center"} onClick={() => props.original.editRow(props.original.ID)} />,
      isButton: true,
      classList: 'd-none d-md-block d-lg-block d-xl-block'
    }

    const delet = {
      width: 50,
      Cell: props => <i className="simple-icon-trash icon-action d-flex align-items-center" onClick={() => props.original.deleteRow(props.original.ID)} />,
      isButton: true,
      classList: 'd-none d-md-block d-lg-block d-xl-block'
    }

    let extra = []
    if (this.view.extras && this.view.extras.itemsInRowsTable && this.view.extras.itemsInRowsTable.length > 0) {
      const maxActions = this.view.extras.maxActions || 0
      this.view.extras.itemsInRowsTable.slice(0, maxActions).forEach(item => {
        extra.push({
          width: 50,
          Cell: props =>
            <div className="d-flex">
              <i
                className={item.icon + " icon-action"}
                id={"UncontrolledTooltip" + props.index}
                onClick={() => {
                  this.setState({ idItemPreSelected: props.original.ID }, () => {
                    item.onClick(props.original, this);
                    this.listenBtnActionsFormFilter('menu', item, props.original);
                  });
                }
              }
              />
              <UncontrolledTooltip
                placement="left"
                target={"UncontrolledTooltip" + props.index}>
                {AppLocale[this.props.locale].messages[item.name]?? item.name}
              </UncontrolledTooltip>
            </div>,
            isButton: true,
            classList: 'd-none d-md-block d-lg-block d-xl-block'
        })
      });

      if ((this.view.extras.itemsInRowsTable.length - maxActions) > 0) {
        extra.push(
          {
            width: 50,
            Cell: props => 
              <CustomDropdown
                icon="simple-icon-options-vertical"
                showMenuOnHover={true}
                items={this.view.extras.itemsInRowsTable.slice(maxActions, this.view.extras.itemsInRowsTable.length)}
                rowData={props.original}
                ctx={this}
                listenBtnActions={this.listenBtnActionsFormFilter}
              />,
              isButton: true,
              classList: 'd-none d-md-block d-lg-block d-xl-block'
          }
        )
      }
    }

    /* add drop down menu for mobile screens */
    if (temp && temp.length > 0 && (this.view.actions.edit || this.view.actions.delete || (this.view.extras && this.view.extras.itemsInRowsTable)) && temp[0].type !== 'concept') {
      temp[0].Cell = props =>
      <div className="d-flex justify-content-between align-items-center">
        <div className="value w-100">{temp[0].isDate ? fDate(props, temp[0].format) : temp[0].type === "img" ? colImg(props) : temp[0].type === "html" ? temp[0].cell(props) : props.value}</div>
        <div className="main-list">
          <CustomDropdown
            icon="simple-icon-options-vertical"
            items={ (() => {
              let r = []
                if (this.view.actions.edit) r.push({ icon: (this.state.writePermission ? "simple-icon-pencil" : "simple-icon-eye"), name:'', onClick: () => props.original.editRow(props.original.ID) })
                if (this.view.actions.delete) r.push({ icon: 'simple-icon-trash', name: '', onClick: () => props.original.deleteRow(props.original.ID) })
                if (this.view.extras && this.view.extras.itemsInRowsTable) r = r.concat(this.view.extras.itemsInRowsTable)
              return r
            })()}
            rowData={props.original}
            ctx={this}
          />
        </div>
      </div>
    }

    if (this.view.extras && this.view.extras.itemsInRowsTable) temp = temp.concat(extra)
    if (this.view.actions.edit) temp.push(edit)
    if (this.view.actions.delete) temp.push(delet)
    this.setState(({ columns: temp }), () => { /*console.log(this.state.columns)*/ })
  }

  query() {
    let pageSize = "?PageSize=" + this.state.pageSize
    let fieldsToFilter = this.state.formFilter?? {};
    // parent ID filter
    if(this.state.parentId) fieldsToFilter.parentId = this.state.parentId;
    // add params
    if(this.props.filterBy) fieldsToFilter = {...fieldsToFilter, ...this.props.filterBy}
    
    let filters = objToQueryString(fieldsToFilter, false, true);
    let search = this.state.search ? ('&filterBy=' + (this.view.actions.search.by || '') + '&' + (this.view.actions.search.paramName || 'filter') +'=' + this.state.search) : ''
    let page = this.state.currentPage ? ('&page=' + this.state.currentPage) : ''
    return pageSize + filters + search + page
  }

  createMsgNoRecords () {
    const formFilter = cloneDeep(this.state.formFilter)
    let msg = null
    if (formFilter &&  Object.values(formFilter).some(val => val !== null && val !== undefined && val !== "")) {
      const filters = Object.entries(formFilter).reduce((acc, [key, value]) => {
        if (value !== null && value !== undefined && value !== "") {
          acc[key] = value
        }
        return acc
      }, {})
      const { L, selects } = this.state
      const fields = this.view.filter.fields.filter(f => Object.keys(filters).indexOf(f.name) > -1 && f.type !== "hidden")
      msg = `${L["main.noRecordsForFilters"]} `
      fields.forEach((field, index) => {
        if (field.type === "select") msg+= selects ? `${L[field.label]?? field.label}: ${selects[field.name]?.label}${index === (fields.length -1) ? ". " : ", "}` : ""
        else msg+= `${L[field.label]?? field.label}: ${filters[field.name]}${index === (fields.length -1) ? ". " : ", "}`
      })
      if (this.view.actions.create) msg += L["main.addRecordsWithCreateButton"]
      this.setState({msgNoRecords: msg})
    }
  }

  getData() {
    this.setState({ progressBar: true })
    let path = `${this.view.config.customPathGet || `${this.state.resource}/get/`}${this.query()}`
    _axios
      .get(path)
      .then(r => {
        if (r.status >= 0 && r.data?.RowCount > -1) {
          this.setState({ rowCount: r.data.RowCount, pageCount: r.data.PageCount, progressBar: false })
          return
        }
        if (this.view.config.remap) r = this.view.config.remap(r, this.view.config.remapRow)

        if (r.status >= 0) {
          if (r.data.Results.length === 0) {
            this.createMsgNoRecords()
            let msg = AppLocale[this.props.locale].messages["main.noRecords"]
            this.props.insideCustomForm ? this.setState({customMsg: msg}) : NotificationManager.success(msg, AppLocale[this.props.locale].messages["main.info"], 5000, null, null, 'outline')
          }
          
          let data = []
          if (this.view.config.getDataSuccess) data = this.view.config.getDataSuccess(r.data.Results)
          else {
            r.data.Results.forEach(e => {
              e.editRow = this.getDataById
              e.deleteRow = this.toggleDelete
              data.push(e)
            })
          }
          this.setState({ data: data, rowCount: r.data.RowCount })
        } else {
          this.props.insideCustomForm ? this.setState({customMsg: r.msg}) : NotificationManager.error(r.msg, 'Opps', 5000, null, null, 'outline')
        }
        this.setState({ progressBar: false })
      })
  }

  getDataById = (id, selectedId = true) => {
    if (selectedId) this.setState({idItemSelected: id})
    this.props.setLoader(true)
    var path = `${this.state.resource}/get/${id}`
    _axios
      .get(path)
      .then(r => {
        this.props.setLoader(false)

        if (this.view.form.remapOne) r = this.view.form.remapOne(r)

        if (r.status >= 0) {
          let fields = cloneDeep(this.state.formFields)
          fields.forEach((f) => {
            if (f.type !== 'label' && f.type !== 'alert') f.value = r.data[f.name]
            if (f.type === 'dropzone') f.opts.url = r.data[f.name + 'Url']
            // for collapsible type fields
            if (f.childs) f.childs = (f.childs || []).map(c => ({ ...c, value: r.data[c.name] }))
            // for wizard type fields
            if (f.steps) {
              f.steps = f.steps.map(step => 
                ({ ...step, fields: step.fields.map(field =>
                  (field.type !== 'label' && field.type !== 'alert'
                    ? field.childs 
                      ? { ...field, childs: field.childs.map(c => ({ ...c, value: r.data[c.name] }))}
                      : { ...field, value: r.data[field.name] }
                    : field
                  )
                )})
              )
            }
            // for tabs type fields
            if (f.tabs) f.tabs = f.tabs.map(tab => ({ ...tab, fields: tab.fields.map(field => (field.type !== 'label' && field.type !== 'alert' ? { ...field, value: r.data[field.name] } : field)) }))
          })

          this.setState({ formFields: fields }, () => {
            if (selectedId && !this.state.modal) this.toggle()
            if (this.view.form.onGetDataById) this.view.form.onGetDataById()
          })
        } else NotificationManager.error(r.msg, "Opps", 5000, null, null, 'outline')
        
      }).catch(e => {
        this.props.setLoader(false)
      })
  }

  uploadFiles (id) {
    return new Promise((resolve, reject) => {
      try {
        if (!id) return resolve('empty')
        id = typeof id === 'object' ? id.ID : id

        const dropzones = this.searchDropzones()
        this.setState({ dropzones: dropzones }, () => {
          if (this.state.dropzones.length === 0) return resolve('empty')
          this.props.setLoader(true)

          const error = (error) => {
            this.props.setLoader(false)
            return reject(error)
          }
          const setUploadActive = (data) => {
            if (this.state.uploadActive < this.state.dropzones.length) {
              // console.log('active', this.state.uploadActive)
              this.setState({uploadActive: this.state.uploadActive + 1}, () => {
                if (this.state.uploadActive >= this.state.dropzones.length) {
                  this.props.setLoader(false)
                  return resolve(data)
                }
                this.setState({
                  uploadFiles: {id: id, name: this.state.dropzones[this.state.uploadActive].name, success: setUploadActive, error: error },
                })
              })
            }
          }

          if (this.state.dropzones.length > 0) {
            this.setState({uploadActive: 0}, () => {
              this.setState({
                uploadFiles: {id: id, name: this.state.dropzones[this.state.uploadActive].name, success: setUploadActive, error: error },
              })
            })
          }
        })
      } catch (error) {
        reject(error)
      }
    })
  }

  searchDropzones() {
    let dropzones = this.state.formFields.filter(f => f.type === 'dropzone')
    const wizard = this.state.formFields.find(f => f.type === "wizard")
    if (wizard && Array.isArray(wizard.steps)) {
      const stepId = this.state.form?.flags?.currentStepId
      const currentStep = wizard.steps.find(s => s.id === stepId)
      if (currentStep && Array.isArray(currentStep.fields)) {
        currentStep.fields.forEach(sf => {
          if (sf.type === "dropzone") {
            dropzones = [...dropzones, sf]
          }
          if (sf.type === "fieldset" && Array.isArray(sf.childs)) {
            sf.childs.forEach(f => {
              if (f.type === "dropzone") {
                dropzones = [...dropzones, f]
              }
            })
          }
        })
      }
    }
    return dropzones
  }

  setValueDropZone(form) {
    const dropzones = this.searchDropzones()
    dropzones.forEach(e => {
      if (form[e.name] && Array.isArray(form[e.name])) form[e.name] = null
    })
    return form
  }

  defaultValuesUploadFiles () {
    this.setState({
      dropzones: [],
      uploadActive: 0,
      uploadFiles: null,
    })
  }

  create() {
    this.validateForm().then(() => {
      this.props.setLoader(true)
      const wizard = this.state.wizard
      const stepMethod = wizard?.steps?.find(s => s.id === this.state.form?.flags?.currentStepId)?.method
      let path = this.view.config.customPathPost?? (stepMethod ? stepMethod() : `${this.state.resource}/create`)
      let form = cloneDeep(this.state.form)
      if (this.state.cloning) {
        form.clone = form.ID || this.state.idItemSelected
        delete form.ID
      }
      form = this.setValueDropZone(form)
      // modify values before post
      if (this.view.form.setValuesBeforePost) {
        form = this.view.form.setValuesBeforePost(form)
      }
      _axios
        .post(`${path}${this.state.parentId ? `?parentId=${this.state.parentId}` : ''}`, form)
        .then(r => {
          if (!this.view.form.onCreateSuccess) this.props.setLoader(false)
          ///Temp fix
          // if (!r.status) r = { status: 0, data: r };
          if (r.status === undefined || r.status === null) r = { status: 0, data: r }
          // TBD: user remap in axios for response format
          if (r.status >= 0) {
            this.uploadFiles(r.data).then((response) => {
              this.defaultValuesUploadFiles()
              if (this.view.actions?.create?.reloadGrid) this.getData()
              else if (r.data) {
                const ID = r.data.ID || r.data
                const index = this.state.data.findIndex(e => e.ID === ID )
                let array = [...this.state.data] // make a separate copy of the array
                const rm = this.view.config.remapRow ? this.view.config.remapRow(this.state.form, r.data, 'create', response) : this.state.form
                if (index > -1) {
                  array[index] = { ...array[index], ...rm }
                } else {
                  let newItem = { ...rm }
                  newItem.ID = ID
                  newItem.editRow = this.getDataById
                  newItem.deleteRow = this.toggleDelete
                  array.splice(0, 0, newItem)
                }
                this.setState({ data: array, animateTr: this.animateTrById(ID) }, () => {
                  setTimeout(() => { this.setState({ animateTr: null }) }, 3000)
                })
              }
              if (!this.state.idItemSelected && wizard) this.handleNextStepOfWizard()
              process.nextTick(() => {
                if (this.view.form.onCreateSuccess) this.view.form.onCreateSuccess(r)
                else this.toggle()
                this.props.listenCreateSuccess && this.props.listenCreateSuccess(true)
              })
            })
            .catch((e) => { console.log(e) })
          } else {
            if (this.view.form.onCreateFailure) this.view.form.onCreateFailure(r)
          }
          NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
        })
        .catch((e) => { this.props.setLoader(false) })
    })
    .catch(e => { /* console.log(e) */ })
  }

  edit() {
    this.validateForm().then(() => {
      this.props.setLoader(true);
      const wizard = this.state.wizard
      var path = this.view.config.customPathPost ? this.view.config.customPathPost.replace('{ID}', this.state.idItemSelected) : `${this.state.resource}/edit/${this.state.idItemSelected}`
      var form = cloneDeep(this.state.form)
      // If the editor type field has not changed its value, null must be sent
      let fields = cloneDeep(this.state.formFields)
      fields.forEach((f) => {
        for (const [key] of Object.entries(form)) {
          if (f.type === 'editor' && f.name === key) {
            if (form[key] === this.state.formDefault[key]) form[key] = null
          }
          /* for collapsible type fields */
          if (f.childs && f.childs.length > 0) {
            for (var i=0; i<f.childs.length; i++) {
              if (f.childs[i].type === 'editor' && f.childs[i].name === key) {
                if(form[key] === this.state.formDefault[key]) form[key] = null
              }
            }
          }
        }
      })
      form = this.setValueDropZone(form)
      // modify values before post
      if (this.view.form.setValuesBeforePost) {
        form = this.view.form.setValuesBeforePost(form)
      }
      _axios
        .post(path, form)
        .then(r => {
          if (!this.view.form.onEditSuccess) this.props.setLoader(false)

          ///Temp fix
          if (r.status === undefined || r.status === null) r = { status: 0, data: r }
          // TBD: user remap in axios for response format
          ///

          if (r.status >= 0) {
            this.uploadFiles(r.data).then((response) => {
              this.defaultValuesUploadFiles()
              if (this.view.form.afterEdit) this.view.form.afterEdit()
              if (this.view.actions?.edit?.reloadGrid) this.getData()
              else if (r.data) {
                const index = this.state.data.findIndex((e) => { return e.ID === this.state.idItemSelected })
                var array = [...this.state.data] // make a separate copy of the array
                const rm = this.view.config.remapRow ? this.view.config.remapRow(this.state.form, r.data, 'edit', response) : this.state.form
                array[index] = { ...array[index], ...rm }
                this.setState(({ data: array, animateTr: this.animateTrById(this.state.idItemSelected) }), () => {
                  setTimeout(() => { this.setState({ animateTr: null }) }, 3000)
                })
              }
              if (wizard) this.handleNextStepOfWizard()
              if (this.view.form.onEditSuccess) this.view.form.onEditSuccess(r)
              else this.toggle()
              this.props.listenEditSuccess && this.props.listenEditSuccess(true)
            })
            .catch((e) => { /* console.log(e) */ })
          } else {
            if (this.view.form.onEditFailure) this.view.form.onEditFailure(r)
          }
          NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
        })
        .catch((e) => { this.props.setLoader(false) })
    })
    .catch(e => { /* console.log(e) */ })
  }

  delete() {
    this.props.setLoader(true)
    let path = `${this.state.resource}/delete/${this.state.idItemSelected}?confirm=true`
    _axios
      .post(path)
      .then(r => {
        this.props.setLoader(false)
        if (r.status >= 0) {
          let index = this.state.data.findIndex((e) => { return e.ID === this.state.idItemSelected })
          let array = [...this.state.data]; // make a separate copy of the array
          array.splice(index, 1)
          this.setState({ data: array }, () => {
            this.toggleDelete()
          })
          this.props.listenDeleteSuccess && this.props.listenDeleteSuccess(true)
        }
        NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
      })
      .catch((e) => { this.toggleDelete(); this.props.setLoader(false) })
  }

  resetDataTable() {
    this.setState(({ currentPage: 1 }), () => { this.getData() })
  }

  handleChangeSearch = (e) => {
    this.setState({ search: e.target.value });
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter') this.resetDataTable()
  }

  toggle = async () => {
    if (!this.state.modal && this.view.form?.beforeOpenModal) {
      await this.view.form.beforeOpenModal()
    }
    this.setState(prevState => ({
      modal: !prevState.modal
    }), () => {
      if (this.state.modal) this.setState({showFormCustom: true})
      else {
        this.restoreDefaultValues()
        if (this.view.form.afterCloseModal) {
          this.view.form.afterCloseModal()
        }
      }
    })
  }

  togglePreview = () => {
    this.setState(prevState => ({
      modalPreview: !prevState.modalPreview
    }))
  }

  restoreDefaultValues = () => {
    this.setState({
      idItemSelected: null,
      form: null,
      formDefault: null,
      formFlags: cloneDeep(this.state.formFlagsDefault),
      formFields: this.view?.form?.fields,
      hideBtnSave: this.view?.config?.hideBtnSave,
      showFormCustom: false,
      modalPreview: false,
      btnCancel: "main.cancel",
      btnSave: "main.save",
      btnCreate: "main.create",
      cloning: false
    })
    this.view = cloneDeep(this.viewDefault)
  }

  toggleRight = () => {
    this.setState(prevState => ({
      modalRight: !prevState.modalRight
    }))
  }

  toggleDelete = (id) => {
    this.setState(prevState => ({
      modalDelete: !prevState.modalDelete
    }), () => {
      this.setState(({ idItemSelected: id || null }), () => { /* console.log(this.state.idItemSelected) */ });
    })
  }

  showDialog = (opts) => {
    if(opts){
      this.setState(prevState => {
        let modalGeneric = Object.assign({}, prevState.modalGeneric);
        modalGeneric.title = opts.title
        modalGeneric.msg = opts.msg
        modalGeneric.action = opts.action                  
        return { modalGeneric };                              
      })
    }
    this.setState(prevState => ({
      modalGenericVisible: !prevState.modalGenericVisible
    }), () => { });
  }

  listenStatesForm = (form) => {
    // console.log('statesForm', form)
    this.setState({ form: form })
    if (this.state.formDefault === null && this.state.modal) this.setState({ formDefault: form })
  }

  listenStatesFormFilter = (s) => {
    this.setState({ formFilter: s })
  }

  getValueLabelOfFieldSelect = (s) => {
    let selects = this.state.selects || {}
    selects = {...selects, ...s}
    this.setState({ selects: selects })
  }

  listenBtnActionsFormFilter = (a, s, rowData) => {
    if (a === 'filter') this.resetDataTable()
    else if (a === 'menu') {
      if (s.form) {
        this.setState({ modalRightContent: s.form, idItemPreSelected: rowData.ID }, () => {
          this.toggleRight();
        })
      }
    }
  }

  listenCurrentPage = (p) => {
    this.setState(({ currentPage: p }), () => { this.getData() })
  }

  animateTrById = (id) => {
    let f = (state, rowInfo, column) => {
      if (rowInfo?.row.ID === id || rowInfo?.original.ID === id) {
        return {
          style: {
            animationName: "flash",
            animationDuration: "3s"
          }
        }
      } else return {}
    }
    return f
  }

  getTrProps = (state, rowInfo, column) => {
    const animateProps = this.state.animateTr ? this.state.animateTr(state, rowInfo, column) : {}
    if (!rowInfo?.original || !this.view.actions.edit) return animateProps
    return {
      ...animateProps,
      style: {
        ...animateProps.style,
        cursor: 'pointer'
      },
      onDoubleClick: () => {
        rowInfo.original.editRow(rowInfo.original.ID)
      }
    }
  }

  getTenant = () => { var t = JSON.parse(localStorage.getItem('current_tenant')); return t ? t.id : 0 }

  handleNextStepOfWizard = () => {
    if (!this.nextStep) return
    const currentStep = this.state.wizard.steps.find(s => s.id === this.state.form?.flags?.currentStepId)
    if (currentStep.handleNextStep) currentStep.handleNextStep()
    else this.nextStep()
  }

  toggleDropdown = () => {
    this.setState({dropdown: !this.state.dropdown})
  }

  previewOfGrid = (data) => {
    const previewOfGrid = this.view.preview?.previewOf?.grid
    if (previewOfGrid) {
      this.setState({
        preview: {
          name: previewOfGrid.name,
          data: data,
          handleData: previewOfGrid.handleData,
          toggle: this.togglePreview
        }
      }, () => {
        if (!this.state.modalPreview && window.innerWidth >= 1150) {this.setState({modalPreview: true})}
      })
    }
  }

  previewOfForm = (form) => {
    const previewOfForm = this.view.preview?.previewOf?.form
    if (previewOfForm) {
      this.setState({
        preview: {
          name: previewOfForm.name,
          data: form,
          handleData: previewOfForm.handleData,
          toggle: this.togglePreview
        }
      }, () => {
        if (!this.state.modalPreview && window.innerWidth >= 1150 && this.state.showFormCustom) {this.setState({modalPreview: true})}
      })
    }
  }

  menuOptions = () => {
    const options = []
    if (this.view.actions?.export) options.push({name: "main.excel", onClick: () => { this.ctxExportToExcel.getData() }})
    if (this.view.actions?.print) options.push({name: "main.print", onClick: () => { this.ctxExportToPrint.getData() }})
    if (this.view.actions?.import) options.push({name: `${this.view.id}.importSyncMenu`, onClick: () => { this.ctxImportTo.toggle() }})
    return options                  
  }

  render() {
    const { locale, params } = this.props
    const { L } = this.state
    const TITLE = this.view ? this.view.config.customTitle?? (locale === 'es' ? this.view.label : this.view.labelEn) : ""
    return (
      this.state.authorized && <Fragment>
        {/* HEADER */}
        {!this.props.onlyCrud &&
        <Row>
          <Colxx xxs="12">
            <Row>
              {/* TITLE */}
              {!this.view.config.hiddenTitle && 
                <Colxx xxs="10">
                  {/*!this.view.config.hiddenTitle && <Breadcrumb heading={{ name: locale === 'es' ? this.view.label : this.view.labelEn }} match={this.props.match} />*/}
                  { (this.props.insideCustomForm ? <h5>{ TITLE }</h5> : <h1>{ TITLE }</h1>)}
                </Colxx>
              }
              
              {/* ACCIONES EXTRA */}
              {this.view.extras?.items && (this.view.extras.items.length > 1 || this.view.extras.maxItems >= 1) &&
                <Colxx xxs="2">
                  <div style={{ marginLeft: '-12px' }} className="float-right">
                    <CustomDropdown icon="simple-icon-options-vertical" showMenuOnHover={true} items={this.view.extras.items} addCheck={this.view.extras.addCheck} ctx={this} listenBtnActions={this.listenBtnActionsFormFilter} />
                  </div>
                </Colxx>
              }
            </Row>

            {params?.setupMsg && <Alert className="rounded" color="warning">{params.setupMsg}</Alert>}

            {/* FORM EXTRAS */}
            {this.view.extras?.forms && 
              <Row>
                  {this.view.extras.forms.map((f, index) => {
                    if (f.spacer) return (<Colxx md={f.spacer}></Colxx>)
                    else if (f.type === 'sideToSide') return (
                      <Colxx md={12} key={'extra-form'+index}>
                        <SideToSide
                          configLeft={f.configLeft}
                          configRight={f.configRight}
                        />
                      </Colxx>
                    )
                    else if (f.type === 'customComponent') return (
                      <Colxx md={12} key={'extra-form'+index}>
                        {f.component && <f.component></f.component>}
                      </Colxx>
                    )
                    else return (
                      <Colxx md={f.col} key={'extra-form'+index}>
                        <div className="mb-4">
                          <FormSmart
                            title={L[f.name]?? f.name}
                            fields={f.fields}
                            buttons={f.buttons}
                            getUrl={f.getUrlF ? f.getUrlF(this) : f.getUrl.replace('{ID}', this.getTenant())}
                            postUrl={f.postUrlF ? f.postUrlF(this) : f.postUrl.replace('{ID}', this.getTenant())}
                            listenBtnActions={this.listenBtnActionsFormFilter}
                            onSuccess={f.onSuccess ? (s) => f.onSuccess(s) : () => { }}
                            remap={f.remap}
                            sideToSide={f.sideToSide}
                          />
                        </div>
                      </Colxx>
                    )
                  })}
              </Row> 
            }
          
            {/* FILTERS */}
            {this.view.filter &&
              <Row>
                <Colxx xxs="12">
                  <FormCustom
                    id={"form-flt"}
                    fields={this.view.filter.fields}
                    buttons={this.view.filter.buttons}
                    listenStates={this.listenStatesFormFilter}
                    listenBtnActions={this.listenBtnActionsFormFilter}
                    getValueLabelOfFieldSelect={this.getValueLabelOfFieldSelect}
                  />
                </Colxx>
              </Row>
            }

            {/* BUTONS ACTIONS */}
            {!this.view.config.hiddenButtons &&
              <Row>
                <Colxx xxs="12">
                  <div className="mb-3 d-flex align-items-center justify-content-between div-content">
                    <div>
                      {/* SEARCH */}
                      {this.view.actions?.search &&
                        <div className="search-lg d-inline-block">
                          <input
                            type="text"
                            id="search"
                            value={this.state.search}
                            placeholder={L['main.search'] + (this.view.actions.search.by ? ` ${L['main.by']} ${this.view.actions.search.by} ` : '')}
                            onChange={this.handleChangeSearch}
                            onKeyPress={this.handleKeyPress}
                          />
                          <i
                            className={this.state.search ? "simple-icon-close" : "simple-icon-magnifier"}
                            onClick={() => { this.setState(({ search: '' }), () => { this.resetDataTable() }) }}
                          ></i>
                        </div>
                      }
                    </div>

                    <div className="d-flex">
                      {/* CREATE */}
                      {this.view.actions?.create &&
                        <Button color="primary" size="sm" className="mr-2" onClick={() => { this.view.actions.create.btn ? this.view.actions.create.btn(this) : this.toggle() }}>
                          <i className="simple-icon-plus"></i> {L["main.create"]}
                        </Button>
                      }

                      {/* IMPORT DATA */}
                      {this.view.actions?.import && 
                        <ImportTo
                          ctx={this}
                          moduleName={this.view.id}
                          uploadModuleName={this.view.actions.import.moduleName}
                          templateFile={this.view.actions.import.templateFile}
                          ctxImportTo={ctx => this.ctxImportTo = ctx}
                          hideButton={this.state.data.length > 0}
                        />
                      }

                      {/* OTHER BUTTONS */}
                      {this.view.extras?.items && this.view.extras.items.length === 1 && !this.view.extras.maxItems &&
                        <Button color="primary" size="sm" className="mr-2" onClick={() => { this.view.extras.items[0].onClick(this) }}>
                          <i className={this.view.extras.items[0].icon}></i> {L[this.view.extras.items[0].name]?? this.view.extras.items[0].name}
                        </Button>
                      }

                      {(this.view.actions?.export || this.view.actions?.print || this.view.actions?.import) && <CustomDropdown
                        size={"sm"}
                        label={"main.more"}
                        direction="left"
                        items={this.menuOptions()}
                      />}
                    </div>
                    
                    {/* EXPORT EXCEL */}
                    {this.view.actions?.export &&
                      <ExportTo
                        ctxParent={this}
                        to="excel"
                        local={this.view.actions.export.local}
                        remap={this.view.actions.export.remap}
                        columns={this.view.columns}
                        filename={locale === 'es' ? this.view.label : this.view.labelEn}
                        hideButton={true}
                        ctxExportTo={ctx => this.ctxExportToExcel = ctx}
                      />
                    }

                    {/* PRINT */}
                    {this.view.actions?.print &&
                      <ExportTo
                        ctxParent={this}
                        to="print"
                        local={this.view.actions.export.local}
                        remap={this.view.actions.print.remap}
                        columns={this.view.columns}
                        filename={locale === 'es' ? this.view.label : this.view.labelEn}
                        hideButton={true}
                        ctxExportTo={ctx => this.ctxExportToPrint = ctx}
                      />
                    }

                    {/* DATATABLE CONTROLS */}
                    {/*
                    {this.view.config && this.view.config.list &&
                      <div id="displayOptions" className="datatable-controls">
                        <div
                          id="mode-datatable"
                          className={"control-icon view-icon " + (!this.state.dataTableList ? "active" : "")}
                          onClick={() => { this.setState({ dataTableList: false }) }}
                        >
                          <DataListIcon />
                          <UncontrolledTooltip placement="top" target={"mode-datatable"}>Mostrar tabla</UncontrolledTooltip>
                        </div>
                        <div
                          id="mode-list"
                          className={"control-icon view-icon " + (this.state.dataTableList ? "active" : "")}
                          onClick={() => { this.setState({ dataTableList: true }) }}
                        >
                          <ThumbListIcon />
                          <UncontrolledTooltip placement="top" target={"mode-list"}>Mostrar lista</UncontrolledTooltip>
                        </div>
                      </div>
                    }
                    */}
                  
                  </div>
                </Colxx>
              </Row>
            }

            {/* DATATABLE */}
            {!this.view.config.hiddenGrid &&
              <Row>
                <Colxx xxs="12">
                  <DataTable
                    progressBar={this.state.progressBar}
                    data={this.state.data}
                    defaultPageSize={this.state.pageSize}
                    columns={this.state.columns}
                    rowCount={this.state.rowCount}
                    pageCount={this.state.pageCount}
                    listenCurrentPage={this.listenCurrentPage}
                    currentPage={this.state.currentPage}
                    getTrProps={this.getTrProps}
                    dataTableList={this.state.dataTableList}
                    enableContexMenu={this.view.config.enableContexMenu}
                    customMsg={this.state.customMsg}
                    msgNoRecords={this.state.msgNoRecords}
                    hidePagination={this.state.hidePagination}
                  />
                </Colxx>
              </Row>
            }

            {/* CUSTOM COMPONENT */}
            {this.view.customComponent &&
              <Row>
                <Colxx xxs="12">
                  <this.view.customComponent ctxCruGrid={this} L={L}></this.view.customComponent>
                </Colxx>
              </Row>
            }
          </Colxx>
        </Row>
        }

        {/* MODAL CREATE/UPDATE */}
        {this.state.formFields?.length > 0 &&
        <CustomModal 
          isOpen={this.state.modal}
          toggle={this.toggle}
          backdrop={'static'}
          wrapClassName={this.view.config.modal?.wrapClassName ?? 'modal-right'}
          size={this.view.config.modal?.size ?? 'lg'}
        >
          <ModalHeader
            toggle={this.toggle}
            close={this.view.form?.cloneable && this.state.idItemSelected ? (
              <span className="d-inline-flex align-items-center">
                <Button
                  color={this.state.cloning ? "primary" : "light"}
                  className="rounded-circle d-inline-flex align-items-center justify-content-center mr-2 p-0"
                  style={{ width: "2rem", height: "2rem" }}
                  onClick={() => this.setState(prev => ({ cloning: !prev.cloning }))}
                >
                  <i className="iconsminds-duplicate-layer" />
                </Button>
                <button type="button" onClick={this.toggle} className="close" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </span>
            ) : undefined}
          >
            {(TITLE ? `${TITLE}: ` : "")}
            <small>{this.state.idItemSelected ? L["main.edit"] : L["main.create"]}</small>
          </ModalHeader>
          <ModalBody>
            {this.state.formFields.length > 0 && this.state.showFormCustom &&
              <FormCustom
                id={"form-crud"}
                edit={this.state.idItemSelected ? true : false}
                flags={this.state.formFlags}
                fields={this.state.formFields}
                detailGrid={this.view.form.detailGrid}
                subforms={this.view.form.subforms}
                subGrids={this.view.form.subGrids}
                uploadFiles={this.state.uploadFiles}
                validateFor={fn => this.validateFor = fn}
                validate={fn => this.validateForm = fn}
                nextStep={fn => this.nextStep = fn}
                listenBtnActions={this.listenBtnActionsFormFilter}
                listenChangeStep={this.listenChangeStep}
                listenStates={this.listenStatesForm}
                didUpdateStates={true}
                cloning={this.state.cloning}
                history={this.props.history}
              />
            }
          </ModalBody>
          <ModalFooter>
            {!this.state.hideBtnSave && this.state.writePermission &&
              <Button
                color="primary"
                size="sm"
                onClick={() => {
                  if (this.state.cloning) this.create()
                  else if (this.view.form.handleSaveChanges) this.view.form.handleSaveChanges(this)
                  else if (this.state.idItemSelected) this.edit()
                  else this.create()
                }}
              >
                {this.state.cloning
                  ? L["main.createClone"]
                  : this.state.idItemSelected
                    ? L[this.state.btnSave]
                    : this.state.wizard
                      ? ((this.state.form?.flags?.currentStepIndex + 1 >= this.state.form?.flags?.stepsLength ? L["main.finish"] : L["main.next"]))
                      : L[this.state.btnCreate]
                }
              </Button>
            }
            <Button outline color="secondary" size="sm" onClick={this.toggle}>{L[this.state.btnCancel]}</Button>
          </ModalFooter>
        </CustomModal>
        }
        
        {/* MODAL FOR CUSTOM MENU FORMS */}
        <CustomModal
          isOpen={this.state.modalRight}
          toggle={this.toggleRight}
          wrapClassName="modal-right"
          backdrop={'static'}
          size={this.state.modalRightSize}
        >
          <ModalHeader toggle={this.toggleRight}>{this.state.modalRight?L[this.state.modalRightContent.name]?? this.state.modalRightContent.name:''}</ModalHeader>
          <ModalBody className="p-0">
            {this.state.modalRight && <FormSmart
              fields={this.state.modalRightContent.fields}
              buttons={this.state.modalRightContent.buttons}
              subforms={this.state.modalRightContent.subforms}
              getUrl={this.state.modalRightContent.getUrlF ? this.state.modalRightContent.getUrlF(this) : this.state.modalRightContent.getUrl ? (this.state.modalRightContent.getUrl + this.query()) : null }
              postUrl={this.state.modalRightContent.postUrlF ? this.state.modalRightContent.postUrlF(this) : this.state.modalRightContent.postUrl + this.query()}
              okMsg={this.state.modalRightContent.okMsg}
              onSuccess={this.toggleRight}
              remapGET={this.state.modalRightContent.remapGET}
              detailGrid={this.state.modalRightContent.detailGrid}
              history={this.props.history}
            />}
          </ModalBody>
        </CustomModal>

        {/* MODAL PREVIEW */}
        {this.state.modalPreview && (this.view.preview?.renderIf ? this.view.preview.renderIf() : true) &&
          <Modal
            isOpen={this.state.modalPreview}
            toggle={this.togglePreview}
            backdrop={false}
            wrapClassName={'modal-preview'}
            size={'md'}
          >
            {this.state.preview && <this.view.preview.template L={L} preview={this.state.preview}/>}
          </Modal>
        }
        
        {/* MODAL DELETE */}
        <Dialog
          isOpen={this.state.modalDelete}
          toggle={this.toggleDelete}
          title={L['main.delete']}
          msg={L['main.msgDelete']}
          confirm={(r) => { r ? this.delete() : this.toggleDelete() }}
        >
        </Dialog>

        {/* MODAL GENERIC */}
        <Dialog
          isOpen={this.state.modalGenericVisible}
          toggle={this.showDialog}
          title={this.state.modalGeneric.title}
          msg={this.state.modalGeneric.msg}
          confirm={(r) => { this.state.modalGeneric.action(r); this.showDialog() }}
        >
        </Dialog>
      </Fragment>
    )
  }
}

const mapStateToProps = ({ settings, menu, utils, authUser }) => {
  const { menuItems } = menu
  const { locale } = settings
  const { deepLink, params } = utils
  const { userAdmin } = authUser
  return { locale, menuItems, deepLink, userAdmin, params }
}

export default connect(mapStateToProps, { setLoader, setDeeplink, setParams })(CrudGrid)